import { useTranslation } from 'react-i18next';

import { Link, StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectStyle } from 'PDF/helpers/documentStyle';

import { WatermarkSvgComponent } from '../Watermark';

interface IPageNumberFooterProps {
  isStandardOrLightTariff: boolean;
}

export const PageNumberFooter = ({ isStandardOrLightTariff }: IPageNumberFooterProps) => {
  const { t } = useTranslation();
  const coverTitle =
    JSON.parse(localStorage.getItem('business-tool') || '{}')?.state?.businessPlanChapters?.EXECUTIVE_SUMMARY
      ?.companyDescription?.coverTitle || '';

  return (
    <View fixed style={styles.footerContainer}>
      <Link src={`#tableOfContents`} style={[styles.link, getColorObjectStyle(8, 'color')]}>
        {t('pdfPages.moveToContents')}
      </Link>
      {!isStandardOrLightTariff && (
        <Link fixed href="https://growexa.com" style={styles.watermarkLink}>
          <WatermarkSvgComponent />
        </Link>
      )}
      <View style={styles.pageNumberWrapper}>
        <Text style={styles.pageNumberText}>{coverTitle}</Text>
        <View style={styles.pageNumberLine} />
        <Text style={styles.pageNumberText} render={({ pageNumber }) => `${pageNumber}`} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  footerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolute',
    right: 36,
    left: 36,
    bottom: 17,
  },
  pageNumberWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    color: '#212121',
  },
  pageNumberText: {
    fontFamily: 'Noto',
    fontWeight: 300,
    fontSize: 7,
  },
  pageNumberLine: {
    height: 10,
    width: 0.5,
    backgroundColor: '#212121',
    marginRight: 4,
    marginLeft: 4,
  },
  link: {
    fontFamily: 'Noto',
    fontSize: 7,
    fontWeight: 300,
    textDecoration: 'none',
  },

  watermarkLink: {
    marginLeft: '-55px',
  },
});
